
import configCard from './config-card.vue';

export default {
  components: {
    configCard: configCard
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formValue: {
        tag_ids: [],
        tag_text: ''
      }
    };
  },

  watch: {
    'formValue.tag_ids': function formValueTag_ids(val) {
      this.schemeValue.tag_ids = val;
    },
    'schemeValue.fetch_data': function schemeValueFetch_data(val) {
      if (val) {
        this.fillForm();
      }
    }
  },
  computed: {
    formItemList: function formItemList() {
      var list = [{
        visible: !this.readOnly,
        label: '配置创意标签：',
        type: 'business',
        subtype: 'creation-tag-cascader-multi',
        prop: 'tag_ids',
        params: {
          disabled: false,
          params: {
            type: 1
          }
        },
        rules: [{
          required: true,
          message: '请配置创意标签',
          trigger: 'change'
        }]
      }, {
        visible: this.readOnly,
        label: '配置创意标签：',
        type: 'plain-text',
        prop: 'tag_text'
      }];
      return list;
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      this.formValue.tag_ids = this.schemeValue.tag_ids;
      if (this.schemeValue.creation_tags && this.schemeValue.creation_tags.length) {
        this.formValue.tag_text = this.schemeValue.creation_tags.map(function (e) {
          return e.name;
        }).join();
      }
    }
  },
  mounted: function mounted() {}
};